import Vue from 'vue';
import Router from 'vue-router';
import LayoutHome from '@/views/LayoutHome.vue';
import RouterComposite from '../views/composite/RouterComposite';

Vue.use(Router);

let route = [
    {
        path: '/',
        name: 'LayoutHome',
        component: LayoutHome,
        redirect: '/LayoutComposite',
    },
];
route = route.concat(RouterComposite as any);
export default new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: route,
});
